/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react'
import SingleSelect from '../../models/SingleSelect/SingleSelect.js';
import ProgressBubbles from '../../partials/ProgressBubbles/ProgressBubbles.js';
import PopupPointer from '../../partials/PopupPointer/PopupPointer.js';
import Pager from '../../models/Pager/Pager.js';

import './BinaryTally.scss'

const BinaryTally = props => {
    const data =  props.data;

    const [sampleIndex, setSampleIndex] = useState(0);
    const [correctArray, setCorrectArray] = useState(data.samples.map((el, i) => {
        let tempValue = (el.correct === 'share') ? 'share' : 'investigate'
        return tempValue
    }));
    const [tallyArray, setTallyArray] = useState(data.samples.map(() => ''));
    const [currentChoice, setCurrentChoice] = useState(-1);
    const [transition, setTransition] = useState(false);
    const [feedback, setFeedback] = useState(false);
    const [iconVisible, setIconVisible] = useState(false);
    const [selected, setSelected] = useState(-1);
    const [popup, setPopup] = useState(false);
    const [popupText, setPopupText] = useState(null);
    const [allClicked, setAllClicked] = useState(false);
    const [clickedItems, setClickedItems] = useState(data.samples.map(el => false));
    const [allCorrect, setAllCorrect] = useState(false);

    const handleSampleComplete = () => {      
        let tempArray = tallyArray;
        let iconName = (currentChoice === 0) ? 'share' : 'investigate'
        console.log("iconName" , iconName);
        tempArray[sampleIndex] = iconName;
        setTallyArray(tempArray);
        setIconVisible(true)    
        setTimeout(() => {
            if (sampleIndex + 1 < data.samples.length){    
                    setSampleIndex(sampleIndex + 1)
                    setIconVisible(false)                        
            }else{
                //last question
                setTransition(true)
                //props.onComplete();
            } 
        }, 2250);  
    }

    const handleTransitionComplete = () => {
        setTransition(false);
        setFeedback(true);
    }

    const handleSampleClick = (sampleIndex) => {
        setSelected(sampleIndex)
        setPopupText(data.samples[sampleIndex].feedback)
        setPopup(true) 
        let tempArray = clickedItems.map((el, i) => {
            if(el || i === sampleIndex){               
                return true;
            }else{
                return false;
            }
        });
        console.log("tempArray" , tempArray);
        setClickedItems(tempArray);     
    }

    const handleNextClick = () => {       
        if(allClicked){
            props.onComplete(); 
       }   
    }

    const getTotalCorrect = () => {
        let allGood = true;
        data.samples.forEach((el, i) => {
            if(tallyArray[i] !== correctArray[i]){               
                allGood = false          
            }
        });   
        console.log("allGood" , allGood);   
        return allGood   
    }

   
    // check to see when we've clicked on 3 samples
    useEffect(()=>{        
        if(clickedItems.filter(el => !el).length === 3){
            setAllClicked(true)
        }
    },[clickedItems])

    const isOdd = (num) => {
        return num % 2;
    }

    return (
        <div className={`BinaryTally`}>
            {/* {!feedback && */}
                {!transition && !feedback &&
                    <div className="binary-page">
                        <div className="column-right">                   
                            <div className="text-content">
                                {/* header */}
                                <h1 className="header" dangerouslySetInnerHTML={{__html:data.header}}></h1>
                    
                                {/* body text */}
                                <div className="body" dangerouslySetInnerHTML={{
                                    __html:data.body
                                }}></div>  
                            </div>
                        </div>                
                        <div className="column-left">
                            <div className="topbar">
                                <ProgressBubbles total={data.samples.length} current={sampleIndex+1}/> 
                            </div>  
                            <div className={`sample-content`} key={'samp-'+sampleIndex}>
                                {data.samples[sampleIndex].image && <img src={data.samples[sampleIndex].image} alt={'sample'} />}                                      
                                {iconVisible && <div className={`icon ${tallyArray[sampleIndex] === 'share' ? 'share' : 'investigate'}`}></div>}
                                <div className={`text`} dangerouslySetInnerHTML={{__html:data.samples[sampleIndex].text}}></div>
                            </div>  
                            <div className={`overlay-reveal`}>
                                <div className={`instructions`}  key={`inst-${sampleIndex}`} dangerouslySetInnerHTML={{__html:data.instructions}}></div>
                                <SingleSelect 
                                    data={data.samples[sampleIndex]}
                                    onComplete={handleSampleComplete}                   
                                    setCurrentChoice={setCurrentChoice}
                                    key={`sample-${sampleIndex}`}
                                />              
                            </div>                     
                        </div>
                    </div>
                }

            {transition && !feedback &&
                <div className="transition-page">
                    <Pager
                        class={data.transition.class}
                        data={data.transition}
                        onComplete={handleTransitionComplete}
                    /> 
                    <div className="large-symbols"></div>
                </div>
            }          
           
            {feedback && 
                <div className="feedback-page">
                    <div className="column-right">                   
                        <div className="text-content">
                            {/* header */}
                            <h1 className="header" dangerouslySetInnerHTML={{__html:data.feedback.header}}></h1>
                
                            {/* body text */}                     
                            {getTotalCorrect() && <div className="body" dangerouslySetInnerHTML={{
                                __html:data.feedback.body_allcorrect
                            }}></div>} 

                            {!getTotalCorrect() && <div className="body" dangerouslySetInnerHTML={{
                                __html:data.feedback.body
                            }}></div>}

                        </div>
                        {
                        popup && 
                            <div className="scrim"></div>
                        }
                        <div 
                            id={`final-button`}                            
                            className={`global-button ${allClicked ? 'enabled' : 'disabled'}`}               
                            onClick={() => handleNextClick()}>Next</div>
                    </div> 

                    <div className="column-left">                        
                        <div className={`instructions`} dangerouslySetInnerHTML={{__html:data.feedback.instructions}}></div>
                        <div className="samples">
                        {data.samples.map((el, i) => {                                                     
                            return <div className={`sample ${i === selected ? 'selected' : 'not-selected'} ${tallyArray[i] !== correctArray[i] ? 'consider' : ''} ${!popup && clickedItems[i] ? 'visited' : ''} ${popup && i !== selected ? 'mask' : ''}`}
                                key={`sample-${i}`}       
                                onClick={() => handleSampleClick(i)}>
                                <img src={el.image} alt={'sample'}/>
                                {/* {tallyArray[i] === correctArray[i] && <div className={`icon ${tallyArray[i] === 'share' ? 'share' : 'investigate'}`}></div>} */}
                              
                                {tallyArray[i] !== correctArray[i] && <div className={`consider-box`}>
                                    <div className={`youchose`} dangerouslySetInnerHTML={{__html:data.feedback.youchose + ' ' + tallyArray[i]}}></div>
                                    <div className={`consider`} dangerouslySetInnerHTML={{__html:data.feedback.consider + ' ' + correctArray[i]}}></div>
                                </div>}
                            </div>                            
                        })}
                        </div>
                    </div>

                    {popup && 
                        <PopupPointer class={data.samples[selected].feedback_pos} text={popupText} onClose={() => {setPopup(false)}} />
                    }                   
                
                </div>
            }
        </div>
    )
}

export default BinaryTally